import { Navigate, Route, Routes } from "react-router-dom"
import style from './Main.module.scss'
import NavMenuContainer from "./Nav-Menu/Nav-Menu-Container"
import SettingsContainer from "./Settings/SettingsContainer"
import Contacts from "./Contacts/Contacts"
import PreAppPage from "../Pages/PreAppPage"
import ClientsContainer from "./Clients/ClientsContainer"
import ManagersContainer from "./Manager/ManagersContainer"



const GuestMenu = () => {
    return (
        <Routes>
            <Route path="contacts/" element={<PreAppPage><Contacts /></PreAppPage>} />
            <Route path="*" element={<Navigate replace to="/contacts" />} />
        </Routes>
    )
}


const ClientMenu = () => {
    return (
        <Routes>
            <Route path="managers" element={<PreAppPage><Contacts /></PreAppPage>} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="clients" element={<ClientsContainer />} >
            </Route>
            <Route path="*" element={<Navigate replace to="/contacts" />} />

        </Routes>
    )
}

const ManagerMenu = () => {
    return (
        <Routes>

            <Route path="*" element={<Navigate replace to="/contacts" />} />
            {/* <Route path="clients" element={<ClientsContainer />} >
            </Route>

            <Route path="clients/add" element={<ClientContainer />} />
            <Route path="clients/:clientId" element={<ClientContainer isNew={false} />} />
            <Route path="clients/:add" element={<ClientContainer isNew={true} />} />
            <Route path="clients/:error" element={<Error />} /> */}


        </Routes>
    )
}

const AdminMenu = () => {
    return (
        <Routes>

            <Route path="settings" element={<SettingsContainer />} />


            {/* <Route path="clients" element={<ClientsContainer />} >

            </Route>

            <Route path="clients/add" element={<ClientContainer />} />
            <Route path="clients/:clientId" element={<ClientContainer isNew={false} />} />
            <Route path="clients/:add" element={<ClientContainer isNew={true} />} />
            <Route path="clients/:error" element={<Error />} /> */}


            <Route path="clients" element={<ClientsContainer />} >

            </Route>

            <Route path="managers" element={<ManagersContainer />} >

            </Route>

            {/* <Route path="clients/add" element={<ClientContainer />} />
            <Route path="clients/:clientId" element={<ClientContainer isNew={false} />} />
            <Route path="clients/:add" element={<ClientContainer isNew={true} />} />
            <Route path="clients/:error" element={<Error />} /> */}

            {/* <Route path="*" element={<Navigate replace to="/contacts" />} /> */}
        </Routes>
    )
}

const Main = ({ user }) => {

    let main = <ClientMenu />
    if (user.role === 'manager') {
        main = <ManagerMenu />
    } else if (user.role === 'admin') {
        main = <AdminMenu />
    } else if (user.role === 'client') {
        main = <ClientMenu />
    } else {
        main = <GuestMenu />
    }

    return (

        <main id={style.main}>
            <div className={style.container}>
                <div id={style.left__area}>
                    <div id={style.left__menu}>
                        <NavMenuContainer />
                    </div>
                </div>
                <div id={style.main__area}>
                    {main}
                </div>
            </div>
        </main>

    )
}

export default Main